import { defineMessages } from 'react-intl';

export default defineMessages({
	exceedsMaxHeading: {
		id: 'teams.coveredLives.exceeds.heading',
		defaultMessage: 'Buying for a larger business?',
		description: 'Prompt shown to user when more than 20 covered lives has been selected.',
	},
	exceedsMaxCopy: {
		id: 'teams.coveredLives.exceeds.copy',
		defaultMessage:
			'If you would like to purchase coverage for more than {maxCoveredLives} eligible team members, please contact sales to book a demo.',
		description: 'Prompt shown to user when more than 20 covered lives has been selected.',
	},
	exceeedsMaxCtaCopy: {
		id: 'teams.coveredLives.exceeds.ctaCopy',
		defaultMessage: 'Book a demo',
		description: 'Prompt shown to user when more than 20 covered lives has been selected.',
	},
	coveredLivesNumber: {
		id: 'teams.coveredLives.number',
		defaultMessage: 'Text that prompts user to input number of covered lives they would like to purchase',
		description: 'Text prompting the user to input the number of covered lives they would like to purchase',
	},
	coveredLivesPricingHeading: {
		id: 'teams.coveredLives.pricing.heading',
		defaultMessage: 'Choose between 5 - 300',
		description: 'Heading for the pricing section.',
	},
	pricePerUser: {
		id: 'teams.coveredLives.pricePerUser',
		defaultMessage: 'Price per covered life',
		description: 'Label for the form input field.',
	},
	pricePerYear: {
		id: 'teams.coveredLives.yearly',
		defaultMessage: '{annualPrice}/year',
		description: 'Total yearly cost(or savings) of their selected plan.',
	},
	pricePerYearIndividualPerYearUpdated: {
		id: 'teams.coveredLives.yearlyIndividualUpdated',
		defaultMessage: 'Individual / Year',
		description: 'label for the individual yearly cost(or savings) of their selected plan.',
	},
	pricePerYearTotalPerYearUpdated: {
		id: 'teams.coveredLives.yearlyTotalUpdated',
		defaultMessage: 'Total / Year',
		description: 'label for the total yearly cost(or savings) of their selected plan.',
	},
	pricePerYearTotalSavings: {
		id: 'teams.coveredLives.pricePerYearTotalSavings',
		defaultMessage: 'Save {totalSavings}',
		description: 'Total savings on the selected plan',
	},
	savingPerUser: {
		id: 'teams.coveredLives.savings',
		defaultMessage: 'Saving {savingsAmount}/user',
		description: 'Amount of savings per user.',
	},
	savingPerUserUpdated: {
		id: 'teams.coveredLives.savingsUpdated',
		defaultMessage: 'Save {savingsAmount} each',
		description: 'Amount of savings per user.',
	},
	totalCost: {
		id: 'teams.coveredLives.total',
		defaultMessage: 'Total',
		description: 'Total cost label.',
	},
	ctaCopy: {
		id: 'teams.coveredLives.ctaCopy',
		defaultMessage: 'Proceed to checkout',
		description: 'Proceed to checkout button copy.',
	},
	coveredLivesCountLabel: {
		id: 'teams.coveredLives.coveredLivesCountLabel',
		defaultMessage: '{coveredLivesCount} Users',
		description: 'The number of covered lives selected for the plan.',
	},
	exceedsCoveredLivesMaxHeading: {
		id: 'teams.coveredLives.exceedsHeading',
		defaultMessage: 'Calm Health might be a better fit for your needs.',
		description: 'The heading for when the user exceeds the covered lives max',
	},
	exceedsCoveredLivesMaxSubheading: {
		id: 'teams.coveredLives.exceedsSubHeading',
		defaultMessage:
			'Connect with our team to learn how to achieve the results that matter most to your organization.',
		description: 'The subheading for when the user exceeds the covered lives max',
	},
	bookADemoButton: {
		id: 'teams.coveredLives.meetWithASpecialistButton',
		defaultMessage: 'Book a demo',
		description: 'The button text for when the user exceeds the covered lives max',
	},
	exceedsMinToSpeakWithConsultantHeading: {
		id: 'teams.coveredLives.exceedsMinToSpeakWithConsultantHeading',
		defaultMessage: 'Prefer to speak with a specialist first?',
		description: 'The heading for when the user exceeds the covered lives min to speak with a consultant',
	},
	exceedsMinToSpeakWithConsultantSubheading: {
		id: 'teams.coveredLives.exceedsMinToSpeakWithConsultantSubheading',
		defaultMessage:
			'Connect with our team to learn how to achieve the results that matter most to your organization.',
		description: 'The subheading for when the user exceeds the covered lives min to speak with a consultant',
	},
	bookAConsultationButton: {
		id: 'teams.coveredLives.bookAConsultationButton',
		defaultMessage: 'Book A Consultation',
		description: 'The button text for when the user exceeds the covered lives min to speak with a consultant',
	},
	exceedsCoveredLivesErrorCopy: {
		id: 'teams.coveredLives.exceedsCoveredLivesErrorCopy',
		defaultMessage: '5 - 300 employees only',
		description: 'The error message for when the user exceeds the covered lives max',
	},
});
